// extracted by mini-css-extract-plugin
module.exports = {"product-pod__price":"product-pod__price--ij5y3"};